import { useEffect, useState } from 'react'
import { trackThemeChanged } from '../../analytics/track'
import {
  applyWebsiteTheme,
  bootWebsiteTheme,
  type WebsiteTheme,
} from '../website-theme'

function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.2 5.2l1.6 1.6M17.2 17.2l1.6 1.6M18.8 5.2l-1.6 1.6M6.8 17.2l-1.6 1.6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  )
}

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 14.5A8.5 8.5 0 1 1 9.5 3 7 7 0 0 0 21 14.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TradeThemeToggle() {
  const [theme, setTheme] = useState<WebsiteTheme>(() => bootWebsiteTheme())

  useEffect(() => {
    applyWebsiteTheme(theme)
  }, [theme])

  function choose(next: WebsiteTheme) {
    if (next === theme) return
    setTheme(next)
    trackThemeChanged(next)
  }

  return (
    <div className="tl-theme" role="group" aria-label="Color theme">
      <button
        type="button"
        className={`tl-theme__btn${theme === 'light' ? ' is-active' : ''}`}
        aria-pressed={theme === 'light'}
        aria-label="Switch to light theme"
        onClick={() => choose('light')}
      >
        <SunIcon />
      </button>
      <button
        type="button"
        className={`tl-theme__btn${theme === 'dark' ? ' is-active' : ''}`}
        aria-pressed={theme === 'dark'}
        aria-label="Switch to dark theme"
        onClick={() => choose('dark')}
      >
        <MoonIcon />
      </button>
    </div>
  )
}
